import {
    getTracingInstrumentation,
    getWebInstrumentations,
} from '@spotoninc/observability-sdk-web';
import type { InitializeConfig } from '@spotoninc/observability-sdk-web';

type BeforeSendHook = NonNullable<InitializeConfig['beforeSend']>;

// Third-party code (e.g. react-phone-number-input) logs raw E.164 numbers through console.error.
const E164_PHONE_NUMBER = /\+[1-9]\d{7,14}/g;
const PHONE_NUMBER_MASK = '+[redacted-phone]';

export const maskPhoneNumbers = (text: string): string =>
    text.replace(E164_PHONE_NUMBER, PHONE_NUMBER_MASK);

export const maskPhoneNumbersBeforeSend: BeforeSendHook = (item) => {
    const payload = item.payload as {
        message?: unknown;
        value?: unknown;
        context?: Record<string, unknown>;
    };

    if (typeof payload.message === 'string') {
        payload.message = maskPhoneNumbers(payload.message);
    }
    if (typeof payload.value === 'string') {
        payload.value = maskPhoneNumbers(payload.value);
    }
    if (payload.context) {
        Object.entries(payload.context).forEach(([key, contextValue]) => {
            if (typeof contextValue === 'string' && payload.context) {
                payload.context[key] = maskPhoneNumbers(contextValue);
            }
        });
    }

    return item;
};

const faroConfig = {
    url: 'https://faro-collector-prod-us-east-0.grafana.net/collect/9a64f6e884daeff521ad88048cc79a96',
    app: {
        name: 'deal-web',
        version: process.env.NEXT_PUBLIC_BUILD_COMMIT_SHA || '1.0.0',
        environment: process.env.NODE_ENV,
    },
    isolate: true,
    consoleInstrumentation: {
        serializeErrors: true,
    },
    instrumentations: [
        ...getWebInstrumentations(),
        getTracingInstrumentation(),
    ],
    performanceEventSampleRate: 0.1,
    dropTracingXmlHttpRequestEvents: true,
    beforeSend: maskPhoneNumbersBeforeSend,
};

export default faroConfig;
